import React from "react";
import { useTranslation } from "react-i18next";
import "./AboutPrLeaders.css";

import aboutImg from "../../Assets/pranesh-standing.png"; 

export default function AboutPrLeaders() {
  const { t } = useTranslation();

  return (
    <section className="cm-about-pr-leaders-wrapper">
      <div className="cm-about-pr-leaders-container">

        {/* LEFT IMAGE */}
        <div className="cm-about-pr-leaders-image-wrapper">
          <img
            src={aboutImg}
            alt={t("pr_leader_alt")}
            className="cm-about-pr-leaders-image"
          />
        </div>

        {/* RIGHT CONTENT */}
        <div className="cm-about-pr-leaders-content">
          <h3 className="cm-about-pr-leaders-title">
            {t("pr_leader_name")}
          </h3>
          <h4 className="cm-about-pr-leaders-subtitle">
            {t("pr_leader_subtitle")}
          </h4>

          <p className="cm-about-pr-leaders-text">
            {t("pr_leader_description")}
          </p>

          <ul className="cm-about-pr-leaders-list">
            <li>✔️ {t("pr_leader_policy_1")}</li>
            <li>✔️ {t("pr_leader_policy_2")}</li>
            <li>✔️ {t("pr_leader_policy_3")}</li>
          </ul>

          <a href="/about-cmpranesh">
            <button className="cm-about-pr-leaders-btn">
              {t("pr_leader_button")}
            </button>
          </a>
        </div>

      </div>
    </section>
  );
}
